import type { TMember } from './member';
import type { TMedia } from './media';
import type { TOrganization } from './organization';
import type { TUser } from './user';
import type { ValueOf } from './utilities';
import type { TReminder } from './reminder';

export const REMINDER_TEMPLATE_CONTENT_TYPES = {
  text: 'TEXT',
  media: 'MEDIA',
} as const;

export const REMINDER_TEMPLATE_STATUS = {
  saved: 'SAVED',
  rejected: 'REJECTED',
  recieved: 'RECIEVED',
  approved: 'APPROVED',
  pending: 'PENDING',
} as const;

export const REMINDER_TEMPLATE_CATEGORY = {
  utility: 'UTILITY',
  marketing: 'MARKETING',
} as const;

export type TReminderTemplate = {
  id: number;
  organization: TOrganization;
  created_by: TUser;
  created_by_member: TMember;

  attachments: TMedia[];
  created_at: string;
  updated_at: string;
  name: string;
  content: string;
  channel: TReminder['notification_channel'];
  content_type: ValueOf<typeof REMINDER_TEMPLATE_CONTENT_TYPES>;
  status: ValueOf<typeof REMINDER_TEMPLATE_STATUS>;
  category: ValueOf<typeof REMINDER_TEMPLATE_CATEGORY>;
  variables: string;
  sid: string;
  language: string;
  rejection_reason: string;
};
